<style lang="less">
.inputmoney{
	height: 72px;
	overflow: hidden;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	.title{
		font-size: 16px;
		padding-right: 10px;
		font-weight: 400;
		-webkit-box-flex: 0 0 auto; -moz-box-flex: 0 0 auto; -ms-flex: 0 0 auto; flex: 0 0 auto;
	}
	.info{
		height: 70px;
		box-sizing: border-box;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		position: relative;
		.icon{
			font-size: 30px;
			line-height: 36px;
			color: #000;
		}
		.number{
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			padding-left: 4px;
			position: relative;
			z-index: 2;
			input{
				width: 100%;
				overflow: hidden;
				background: none;
				height: 30px;
				border: 0;
				font-size: 30px;
				line-height: 36px;
				font-weight: 400;
			}
		}
		.desc{
			position: absolute;
			left: 4px;
			top: 0px;
			color: #ccc;
			font-size: 14px;
			z-index: 1;
			height: 72px;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			-webkit-box-pack: center; justify-content: center;
		}
		&.active{
			.desc{
				display: none;
			}
		}
	}
	.close{
		height: 72px;
		position: absolute;
		right: 8px;
		top: 0px;
		z-index: 99;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		img{
			width: 18px;
			height: 18px;
		}
	}
	.take_all{
		height: 72px;
		position: absolute;
		right: 8px;
		top: 0px;
		z-index: 99;
		color: #dc2a2a;
		font-size: 12px;
		font-weight: 500;
		text-align: right;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
	}
}
</style>

<template>
	<!-- Main inputmoney -->
	<div class="inputmoney">
		<div class="title">{{title}}</div>
		<div :class="number.length ? 'info active' : 'info' ">
			<!-- <div class="icon">¥</div> -->
			<div class="number">
				<input type="number" value="" placeholder="" maxlength="9" v-model="number" @blur="checkBlurNum" />
			</div>
			<div class="desc">{{number === '' ? placeholder : ''}}</div>
			<div class="close" v-show="number > 0">
				<img src="../assets/id_del.png" @click="close">
			</div>
			<template v-if="takeAll">
				<div class="take_all"  v-show="number == 0 || number == '' ">
					<p @click="setNumberMax">全部取出</p>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
				number: ''
			};
		},
		computed: {
			// number: function () {
			// 	return this.price;
			// }
		},
		components: {
		},
		props: {
			title: {
				type: String,
				default: ''
			},
			price: {
				default: ''
			},
			max: {
				default: 50000
			},
			min: {
				type: Number,
				default: 0
			},
			takeAll: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: '建议转入 100 元以上的金额'
			}
		},
		created: function () {
			this.number = this.price;
		},
		mounted: function () {
		},
		methods: {
			close: function () {
				this.number = '';
			},
			checkBlurNum: function () {
				if (this.number == 0) {
					this.number = '';
				}
				this.check(this.number);
			},
			check: function (n) {
				if (n >= parseFloat(this.max)) {
					this.number = this.max;
				}
				if (n < parseFloat(this.min)) {
					this.number = this.min;
				}
				if (n < 0.02 && n != 0) {
					this.number = 0.01;
				}
				if (n === '') {
					this.number = '';
				}

				this.$emit('price', n);
			},
			setNumberMax: function () {
				this.number = this.max;
				this.$emit('price', this.number);
			}
		},
		watch: {
			number: function (n) {
				this.check(n)
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/inputmoney.vue